module.exports = __webpack_public_path__ + "static/img/bubly-logo@3x.2ad0ce5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pride/bubly-logo@3x.png
// module id = /F6G
// module chunks = 0